var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNextleft = function SvgNextleft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.088 19.784a.562.562 0 0 0-.095-.799l-1.77-1.376-2.326-2.043h14.525c.32 0 .578-.254.578-.568a.573.573 0 0 0-.578-.568H9.042l4.036-3.432a.562.562 0 0 0 .06-.801.584.584 0 0 0-.816-.058l-5.265 4.476a.565.565 0 0 0-.2.425v.005c0 .162.07.316.193.424l3.43 3.01 1.797 1.398c.25.195.613.153.811-.093Z"
  })));
};
export default SvgNextleft;